export const SET_CALCULATED_LAYOUT = "SET_CALCULATED_LAYOUT";
export const SET_ERROR = "SET_ERROR";
export const RESET_STATE = "RESET_STATE";
